import {
    isComponentEnabled,
    NavEventArgs,
    useToggleState,
    NavItem as WebNavItem,
} from '@news-mono/web-common'
import { toFeatureState } from '@west-australian-newspapers/etrigan-feature-toggles-client'
import React, { useEffect, useImperativeHandle, useRef } from 'react'
import { NavItem } from './NavItem'
import { BreakpointKeys } from '../../../__styling'
import {
    StyledSubLinkGroupWrapper,
    StyledSubLinkList,
} from './NavSectionOptions.styled'

export interface NavSectionOptionsProps {
    sectionItems: WebNavItem[]
    onClick: (args: NavEventArgs) => void
    hideAtBreakpoint?: BreakpointKeys
    isOpen: boolean
    name: string
}

export type NavSectionOptionsRef = {
    focus: () => void
} | null

export const NavSectionOptions = React.forwardRef<
    NavSectionOptionsRef,
    NavSectionOptionsProps
>(({ sectionItems, onClick, hideAtBreakpoint, isOpen, name }, ref) => {
    const inputRef = useRef<HTMLUListElement | null>(null)
    const featureState = useToggleState()

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef?.current?.focus()
        },
    }))

    useEffect(() => {
        inputRef?.current?.focus()
    }, [])

    return (
        <StyledSubLinkGroupWrapper
            isOpen={isOpen}
            hideAtBreakpoint={hideAtBreakpoint}
        >
            <StyledSubLinkList
                id={`section-nav-links-${name}`}
                aria-hidden={false}
                role="menu"
                ref={inputRef}
                tabIndex={ref ? 0 : -1}
            >
                {sectionItems.map((navItem: WebNavItem, index: number) =>
                    navItem.feature &&
                    !isComponentEnabled(toFeatureState(featureState), {
                        feature: navItem.feature,
                    }) ? (
                        <></>
                    ) : (
                        <NavItem
                            webNavItem={navItem}
                            onClick={onClick}
                            navPos={index}
                            key={index}
                        />
                    ),
                )}
            </StyledSubLinkList>
        </StyledSubLinkGroupWrapper>
    )
})

NavSectionOptions.displayName = 'TNFlyoutNavSectionOptions'
